import { render } from "./ChatSlogan.vue?vue&type=template&id=e2f2288c&scoped=true"
const script = {}

import "./ChatSlogan.vue?vue&type=style&index=0&id=e2f2288c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f2288c"]])

export default __exports__